export default "__VITE_ASSET__Dd_EOT6k__"